module.exports = __webpack_public_path__ + "static/img/mole.7475b7ad.png";